// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Guadeloupe from '../_raw/flag/icon_flag_guadeloupe.png';

export default () => <img src={Guadeloupe} alt="Guadeloupe" />;
